import { useHoverPopover } from '@app/core/hooks';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useSidenavContext } from '../SidenavContext';
import { PopoverTitle } from './PopoverTitle';
import { SidenavPopover } from './SidenavPopover';
import { commonNavButtonStyles } from './nav-item-styles';

export type NavItemProps = Omit<NavLinkProps, 'component' | 'className' | 'style'> & {
  icon?: React.ReactNode;
};

export const NavItem = ({ icon, children, ...navLinkProps }: NavItemProps) => {
  const { collapsed } = useSidenavContext();
  const {
    anchorEl,
    menuOpen,
    handleMouseEnter,
    handleMouseLeave,
    handlePopoverMouseEnter,
    handlePopoverMouseLeave,
    closePopover,
  } = useHoverPopover({ enabled: collapsed });

  return (
    <>
      <ListItem disablePadding sx={{ display: 'block' }}>
        <ListItemButton
          component={NavLink}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={[
            {
              ...commonNavButtonStyles,
              minHeight: 48,
              px: 1.5,
              '& .MuiListItemText-primary': {
                fontSize: '0.9rem',
                fontWeight: 400,
              },
            },
            collapsed
              ? {
                  justifyContent: 'center',
                }
              : {
                  justifyContent: 'initial',
                },
          ]}
          {...navLinkProps}
        >
          {icon && (
            <ListItemIcon
              sx={[
                {
                  minWidth: 0,
                  justifyContent: 'center',
                  color: '#e9ecef',
                  '.MuiSvgIcon-root': {
                    fontSize: '24px',
                  },
                },
                collapsed
                  ? {
                      mr: 'auto',
                    }
                  : {
                      mr: 2,
                    },
              ]}
            >
              {icon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={children}
            sx={[
              collapsed
                ? {
                    opacity: 0,
                  }
                : {
                    opacity: 1,
                  },
            ]}
          />
        </ListItemButton>
      </ListItem>
      {collapsed && (
        <SidenavPopover
          open={menuOpen}
          anchorEl={anchorEl}
          onClose={closePopover}
          onMouseEnter={handlePopoverMouseEnter}
          onMouseLeave={handlePopoverMouseLeave}
        >
          <PopoverTitle label={children as string} />
        </SidenavPopover>
      )}
    </>
  );
};
